import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

export const COOKIE_NOTICE_KEY = 'diobuch_cookie_notice_v1';

export default function CookieNotice() {
  const [visible, setVisible] = useState(() => {
    try {
      return !window.localStorage.getItem(COOKIE_NOTICE_KEY);
    } catch {
      return true;
    }
  });

  useEffect(() => {
    document.body.classList.toggle('has-cookie-notice', visible);
    return () => document.body.classList.remove('has-cookie-notice');
  }, [visible]);

  function dismiss() {
    try {
      window.localStorage.setItem(COOKIE_NOTICE_KEY, '1');
    } catch {
      /* ignore quota / private mode */
    }
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div className="cookie-notice" role="region" aria-label="Уведомление о cookie">
      <p>
        Сайт использует необходимые cookie (сессия входа и защита форм).{' '}
        <Link to="/privacy">Политика обработки ПДн</Link>
      </p>
      <button type="button" className="btn btn-primary btn-sm" onClick={dismiss}>
        Понятно
      </button>
    </div>
  );
}
